let listening = false;

// Page evidence is request-specific and must stay outside any future page cache.
export default function analyticsClientEvents() {
  const config = document.getElementById('nc-beacon');
  if (listening || !config?.dataset.package || !config.dataset.endpoint) return;
  let endpoint, selectors;
  try {
    endpoint = new URL(config.dataset.endpoint, document.baseURI);
    selectors = Object.entries(JSON.parse(config.dataset.events));
  } catch (_) {
    return;
  }
  if (endpoint.origin !== window.location.origin) return;
  const pagePackage = config.dataset.package;
  const allowedKeys = new Set(selectors.map(([key]) => key));
  const handled = new WeakSet();
  listening = true;
  document.addEventListener('click', event => {
    if (!event.isTrusted || handled.has(event)) return;
    const target = event.target instanceof Element ? event.target : event.target?.parentElement;
    if (!target) return;
    let key, element;
    for (const [candidate, selector] of selectors) {
      const match = target.closest(selector);
      if (match) {
        key = candidate;
        element = match;
        break;
      }
    }
    if (!element) {
      element = target.closest('[data-analytics-event]');
      key = element?.dataset.analyticsEvent;
    }
    if (!key || !allowedKeys.has(key)) return;
    handled.add(event);
    try {
      const body = new FormData();
      body.set('key', key);
      body.set('package', pagePackage);
      try {
        if (navigator.sendBeacon?.(endpoint.href, body)) return;
      } catch (_) {
        // A rejected beacon may still be sent using keepalive fetch.
      }
      window.fetch(endpoint.href, {
        method: 'POST',
        body,
        keepalive: true,
        credentials: 'same-origin'
      }).catch(() => {});
    } catch (_) {
      // Telemetry is best effort; never interfere with the element's default action.
    }
  }, {
    capture: true
  });
}